import { useContext, useEffect, useRef } from "react";
import MyContext from "../../context/MyContext";
import ProjectContext from "../../context/ProjectContext";
import { voiceWindows, duckFactor, DUCK_LEVEL } from "../../Utils/ducking";

// While the editor plays: lowers the background music (if "Lower while characters speak" is on)
// and sound layers with that option during the characters' speech. Draws nothing.
const AudioDucker = () => {
  const { LayersData, CanvasDisplay, onePxEquivalent } = useContext(MyContext);
  const { bgmusicState } = useContext(ProjectContext);
  const layersRef = useRef(LayersData);
  layersRef.current = LayersData;
  const bgRef = useRef(bgmusicState);
  bgRef.current = bgmusicState;

  useEffect(() => {
    if (CanvasDisplay) {
      window.__toonsDuckFactor = 1;
      return undefined;
    }
    const onePx = Number(onePxEquivalent) || Number(localStorage.getItem("onePxEquivalent")) || 0;
    const head = document.getElementById("tickerHead");
    const timer = setInterval(() => {
      const m = head && /translate\(\s*(-?[\d.]+)px/.exec(head.style.transform || "");
      const sec = ((m ? parseFloat(m[1]) : 0) * onePx) / 1000;
      const windows = voiceWindows(layersRef.current, onePx, 0);
      window.__toonsDuckFactor = duckFactor(windows, sec, DUCK_LEVEL);
      const bg = bgRef.current;
      const el = document.getElementById("bgmusicAudioPlayer");
      if (el && bg && bg.src) {
        const base = (Number(bg.volume) || 0) / 100;
        el.volume = Math.min(1, Math.max(0, base * (bg.duck ? duckFactor(windows, sec, bg.duck) : 1)));
      }
    }, 50);
    return () => {
      clearInterval(timer);
      window.__toonsDuckFactor = 1;
    };
  }, [CanvasDisplay, onePxEquivalent]);

  return null;
};

export default AudioDucker;
